import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Admin.css';
import logo from '../logo.svg';

export default function AdminLayout({ children, onLogout }) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    onLogout();
    navigate('/admin/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSidebarCollapsed = () => {
    setSidebarCollapsed((collapsed) => !collapsed);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Close sidebar on navigation
  useEffect(() => {
    closeSidebar();
  }, [navigate]);

  // Close sidebar when clicking outside on mobile
  const handleOverlayClick = () => {
    closeSidebar();
  };

  return (
    <div className={`admin-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Mobile Top Bar */}
      <div className="admin-mobile-topbar">
        <button
          className={`admin-hamburger ${sidebarOpen ? 'open' : ''}`}
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <img src={logo} alt="SNS Building Supplies" className="admin-mobile-logo" />
      </div>

      {/* Mobile Overlay */}
      <div
        className={`admin-overlay ${sidebarOpen ? 'show' : ''}`}
        onClick={handleOverlayClick}
      />

      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''} ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <button
          type="button"
          className="admin-sidebar-collapse"
          onClick={toggleSidebarCollapsed}
          aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {sidebarCollapsed ? '›' : '‹'}
        </button>
        <div className="admin-sidebar-header">
          <img src={logo} alt="SNS Building Supplies" className="admin-logo" />
          <span className="admin-collapsed-mark" aria-hidden="true">S</span>
          <h2>CMS Admin</h2>
          <p>SNS Flooring</p>
        </div>
        <nav className="admin-nav">
          <NavLink
            to="/admin/products"
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={closeSidebar}
            title="Products"
          >
            <span className="admin-nav-icon">P</span>
            <span className="admin-nav-label">
            Products
            </span>
          </NavLink>
          <NavLink
            to="/admin/categories"
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={closeSidebar}
            title="Categories"
          >
            <span className="admin-nav-icon">C</span>
            <span className="admin-nav-label">
            Categories
            </span>
          </NavLink>
          <NavLink
            to="/admin/quoterequests"
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={closeSidebar}
            title="Quote Requests"
          >
            <span className="admin-nav-icon">Q</span>
            <span className="admin-nav-label">
            Quote Requests
            </span>
          </NavLink>
          <NavLink
            to="/admin/reviews"
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={closeSidebar}
            title="Reviews"
          >
            <span className="admin-nav-icon">R</span>
            <span className="admin-nav-label">
            Reviews
            </span>
          </NavLink>
          <NavLink
            to="/admin/content"
            className={({ isActive }) => isActive ? 'active' : ''}
            onClick={closeSidebar}
            title="Content"
          >
            <span className="admin-nav-icon">T</span>
            <span className="admin-nav-label">
            Content
            </span>
          </NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <button onClick={() => { navigate('/'); closeSidebar(); }} className="btn-secondary">
            View Site
          </button>
          <button onClick={handleLogout} className="btn-logout">
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
}
